module.exports = __webpack_public_path__ + "static/themeable_6_month-09eb7bd537cadd22c321364b16c6a370.png";